export enum LoginQueryString {
  forceLogin = 'forceLogin'
}
export enum AccountsQueryString {
  token = 'accounts_token',
  firstAccess = 'accounts_first_access_token',
  loginToken = 'accounts_login_token',
  recoveryToken = 'accounts_recovery_token'
}
